import { CONFIGURABLE_MENU_ID } from '@atlassian/jira-navigation-apps-sidebar-nav4-context/src/common/constants.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import {
	SPACES_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM,
	SPACES_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM,
	CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM,
	CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM,
} from '../../common/constants/index.tsx';
import type { ConfigurableMenuId } from '../../common/types.tsx';
import { useFormattedMessageAndIcon } from '../../common/utils/use-formatted-message-and-icon/index.tsx';

export const useConfigurableMessageAndIconMap = (menuId: ConfigurableMenuId) => {
	const { message, Icon } = getConfigurableMessageAndIcon(menuId);

	return useFormattedMessageAndIcon(message, Icon);
};

export const getConfigurableMessageAndIcon = (menuId: ConfigurableMenuId) => {
	const CONFIGURABLE_MESSAGE_AND_ICON_MAP = expVal(
		'project-terminology-refresh',
		'isEnabled',
		false,
	)
		? CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM
		: CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM;

	const SPACES_MESSAGE_AND_ICON_MAP = expVal('project-terminology-refresh', 'isEnabled', false)
		? SPACES_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM
		: SPACES_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM;

	const { message, Icon } =
		menuId === CONFIGURABLE_MENU_ID.PROJECTS &&
		expVal('project-terminology-refresh', 'isEnabled', false)
			? SPACES_MESSAGE_AND_ICON_MAP
			: CONFIGURABLE_MESSAGE_AND_ICON_MAP[menuId];

	return { message, Icon };
};
